<template>
  <div class="page3_wrapper">
    <SwiperList :swiperList="swiperList"></SwiperList>
    <div class="container">
      <div class="main">
        <div class="breadcrumb">
          <div class="lable">当前位置:</div>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item
              ><a @click="returnPre(0)">首页</a></el-breadcrumb-item
            >
            <el-breadcrumb-item>
              <span v-if="model"
                ><a @click="returnPre(2)">{{ parentActiveTab.label }}</a></span
              >
              <span v-else>{{ parentActiveTab.label }}</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item v-if="model">{{
              model.name
            }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="title">
          <span>{{ parentActiveTab.label }}</span>
        </div>
        <!-- PC -->
        <div v-if="model" class="content">
          <div class="pre_content" v-html="model.content"></div>
        </div>
        <div v-else class="content">
          <div class="list page3_list_table_th">
            <div class="page3_list_table">
              <el-table
                highlight-current-row
                @current-change="handleCurrentChange"
                :data="list"
                style="width: 100%"
              >
                <el-table-column
                  prop="name"
                  :label="
                    parentActiveTab.showtype === '2' ? '标题' : '文档名称'
                  "
                  width="700"
                >
                  <template slot-scope="scope">
                    <span
                      class="jiantou"
                      v-if="parentActiveTab.showtype === '4'"
                      >> </span
                    >{{ scope.row.name }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="publishtime"
                  align="center"
                  :label="
                    parentActiveTab.showtype === '2'
                      ? '发布时间'
                      : '发布公告时间'
                  "
                ></el-table-column>
                <el-table-column
                  label="操作"
                  v-if="parentActiveTab.showtype == '4'"
                >
                  <!--v-if="parentActiveTab.showtype==='4'"-->
                  <template slot-scope="scope">
                    <div style="display: flex; justify-content: center">
                      <div
                        class="btn"
                        v-if="scope.row.url"
                        :class="{ active: activeTab === 1 }"
                        @click.stop="downFile(scope.row.url)"
                      >
                        <div class="button">下载</div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="page">
              <page
                @pageChanged="pageChanged"
                :total="total"
                :currentPage="query.currentPage"
                :pageSize="pageSize"
              ></page>
            </div>
          </div>
        </div>
        <!-- mobile -->
        <div v-if="model" class="mobileContent">
          <div class="pre_content" v-html="model.content"></div>
        </div>
        <div v-else class="mobileContent">
          <div class="list page3_list_table_th">
            <div class="page3_list_table">
              <el-table
                highlight-current-row
                @current-change="handleCurrentChange"
                :data="list"
                style="width: 100%"
              >
                <el-table-column
                  prop="name"
                  :label="
                    parentActiveTab.showtype === '2' ? '标题' : '文档名称'
                  "
                >
                  <template slot-scope="scope">
                    <span
                      class="jiantou"
                      v-if="parentActiveTab.showtype === '4'"
                      >> </span
                    >{{ scope.row.name }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  v-if="parentActiveTab.showtype == '4'"
                >
                  <!--v-if="parentActiveTab.showtype==='4'"-->
                  <template slot-scope="scope">
                    <div style="display: flex; justify-content: center">
                      <div
                        class="btn"
                        v-if="scope.row.url"
                        :class="{ active: activeTab === 1 }"
                        @click.stop="downFile(scope.row.url)"
                      >
                        <div class="button">下载</div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="page">
              <page
                @pageChanged="pageChanged"
                :total="total"
                :currentPage="query.currentPage"
                :pageSize="pageSize"
              ></page>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SwiperList from "./common/SwiperList";
import Page from "./common/Page";
import request from "@/utils/request";
import common from "@/mixin/common";

export default {
  name: "Page3",
  mixins: [common],
  components: { SwiperList, Page },
  data() {
    return {
      swiperList: [],
      total: 0,
      pageSize: 7,
      query: {
        currentPage: 1,
        offset: 0,
      },
      list: [],
      activeTab: "",
      model: "",
    };
  },
  created() {
    this.model = "";
    this.getSwiperList();
    this.getList();
    if (this.parentActiveTab.last) {
      this.model = this.parentActiveTab.last;
    }
  },
  watch: {
    async $route() {
      await this.getList();
      this.getSwiperList();
      this.model = "";
    },
  },
  methods: {
    async getSwiperList() {
      let res = await request({
        method: "get",
        url: "/web/web/getCarfigList",
        params: {
          carfigwmenuid: this.parentActiveTab.value,
          cosid: this.cosId,
        },
      });
      this.swiperList = res;
    },
    returnPre(val) {
      if (val === 2) {
        this.model = "";
      } else {
        this.$router.replace({ path: "/" });
        // this.$store.commit('changeState', {'parentActiveTab': ''})
        // this.$store.commit('changeState', {'childActiveTab': ''})
      }
    },
    download(item) {
      var tempwindow = window.open("_blank");
      let url = window.URL.createObjectURL(
        new Blob(["\uFEFF" + this.picAddr + item.url])
      );
      console.log(url);
      tempwindow.location = this.picAddr + item.url;
    },
    handleCurrentChange(val) {
      if (this.parentActiveTab.showtype === "2") {
        this.model = val;
        let obj = this.parentActiveTab;
        obj.last = val;
        this.$store.commit("changeState", { parentActiveTab: obj });
      }
    },
    pageChanged(val) {
      this.query.currentPage = val.currentPage;
      this.query.limit = val.limit;
      this.query.offset = val.offset;
    },
    async getList() {
      this.query.limit = this.query.limit ? this.query.limit : this.pageSize;
      this.query.cosid = this.cosId;
      this.query.wmenuid = this.parentActiveTab.value;
      this.loading = true;
      if (this.query.wmenuid) {
        let res = await request({
          method: "get",
          url: "/web/web/getNoticePageList",
          params: this.query,
        });
        this.list = res.list;
        this.total = res.count.count;
      }
      this.loading = false;
    },
  },
  computed: {
    ...mapGetters(["parentActiveTab", "childActiveTab", "cosId", "picAddr"]),
  },
};
</script>


<style lang="scss" scoped>
@import "../styles/variables.scss";

@media screen and (min-width: 1201px) {
  .mobileContent {
    display: none;
  }
  .page3_wrapper {
    .container {
      padding: 40px 0;
      display: flex;
      justify-content: center;
      .main {
        background-color: $color-bg-white;
        width: 1201px;
        .breadcrumb {
          padding: 25px 0 10px;
          margin: 0 20px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #fafafa;
          .lable {
            padding-right: 10px;
            color: $color-text-secondary-gray;
          }
        }
        .title {
          padding: 3px 0;
          margin: 40px 20px 2px;
          font-size: $fontsize-large;
          border-left: 5px solid $color-orange;
          span {
            padding-left: 10px;
          }
        }
        .content {
          padding: 30px 20px 0;
          line-height: 28px;
          .list {
            .jiantou {
              color: $color-text-secondary-gray;
            }
            .page {
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: $color-bg-white;
              padding: 27px 0;
            }
            .btn {
              font-size: $fontsize-medium;
              cursor: pointer;
              color: $color-orange;
              display: flex;
              .button {
                padding: 1px 18px;
                border: 1px solid $color-orange;
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .content {
    display: none;
  }
  .container {
    .main {
      .breadcrumb {
        display: flex;
        align-items: center;
        margin: 20px 10px;
      }
      .title {
        text-align: center;
        font-weight: bolder;
        background-color: $color-orange;
        margin: 10px 50px;
        padding: 10px 10px;
        color: #fff;
      }
      .mobileContent {
        margin: 30px 0;
      }
    }
  }
}
</style>